export default "__VITE_ASSET__234a685b__"